// @ts-nocheck
import React from 'react';
import Loadable from 'Jsx/Shared/Loadable';

const QuickEnrollLazy = props => (
  <Loadable
    module={() =>
      import(/* webpackChunkName: "quick-enroll" */ './QuickEnroll')
    }
    {...props}
  />
);

export default QuickEnrollLazy;
